export const getMarketplaceEventProps = props => props;